export default {
  // Settings
  "settings": "設定",
  "profile": "プロフィール",
  "security": "セキュリティ",
  "theme": "テーマ",
  "feedback": "フィードバック",
  "data": "データ",
  "appearance_settings": "外観設定",
  "select_theme": "お好みのテーマを選択",
  "light": "ライト",
  "dark": "ダーク",
  "system": "システム",
  "language_changed": "言語が変更されました：",
  "failed_update_language": "言語の更新に失敗しました",
  "profile_settings": "プロフィール設定",
  "username_cannot_change": "ユーザー名は変更できません。残り",
  "more_days": "日間",
  "email_cannot_change": "メールアドレスは変更できません",
  "profile_links": "プロフィールリンク",
  "link_one": "リンク 1",
  "link_two": "リンク 2",
  "password_change": "パスワード変更",
  "current_password": "現在のパスワード",
  "new_password": "新しいパスワード",
  "confirm_password": "パスワード確認",
  "update_password": "パスワードを更新",
  "password_must_be": "パスワードは8〜25文字である必要があります",
  "security_questions": "セキュリティ質問",
  "security_question": "セキュリティ質問",
  "update_security_questions": "セキュリティ質問を更新",
  "setup_security_questions": "セキュリティ質問を設定",
  "select_question": "質問を選択",
  "your_answer": "あなたの回答",
  "enter_your_answer": "回答を入力してください",
  "submit_feedback": "フィードバックを送信",
  "feedback_type": "フィードバックタイプ",
  "general_feedback": "一般的なフィードバック",
  "bug_report": "バグ報告",
  "feature_request": "機能リクエスト",
  "airport_request": "新しい空港リクエスト",
  "airport_iata": "空港IATA コード",
  "airport_name": "空港名",
  "airport_location": "空港の場所",
  "your_feedback": "あなたのフィードバック",
  "data_management": "データ管理",
  "delete_all_films": "すべてのフィルムを削除",
  "delete_films_warning": "これによりインベントリからすべてのフィルムが完全に削除されます。このアクションは元に戻せません。",
  "delete_all_reviews": "すべてのレビューを削除",
  "delete_reviews_warning": "これによりすべてのレビューが完全に削除されます。このアクションは元に戻せません。",
  "delete_account": "アカウント削除",
  "delete_account_warning": "警告：このアクションは元に戻せません。アカウントとすべてのデータがサーバーから完全に削除されます。",
  "account_deleted_success": "アカウントが正常に削除されました",
  "account_deletion_failed": "アカウントの削除に失敗しました",
  "reviews_deleted_success": "すべてのレビューが正常に削除されました",
  "reviews_deletion_failed": "レビューの削除に失敗しました",
  "films_deleted_success": "すべてのフィルムが正常に削除されました",
  "films_deletion_failed": "フィルムの削除に失敗しました",
  "confirm_delete_films": "すべてのフィルムを削除してもよろしいですか？このアクションは元に戻せません。",
  "confirm_delete_reviews": "すべてのレビューを削除してもよろしいですか？このアクションは元に戻せません。",
  "confirm_delete_account": "アカウントを削除してもよろしいですか？このアクションは元に戻せません。",
  "create_username": "ユ��ザー名を作成",
  "username_required_description": "アカウントのユーザー名を作成してください。ユーザー名は一意である必要があり、文字、数字、アンダースコアを含めることができます。",
  "username": "ユーザー名",
  "username_placeholder": "ユーザー名を入力",
  "username_requirements": "ユーザー名は4〜25文字で、文字、数字、アンダースコアのみを含めることができます。",
  "save_username": "ユーザー名を保存",
  "username_taken": "このユーザー名は既に使用されています",
  "username_set_success": "ユーザー名が正常に設定されました",
  "username_set_error": "ユーザー名の設定に失敗しました"
};
